import type { AssistantPlanRow } from "./types";

export function stepsSummary(
  steps: Pick<AssistantPlanRow["steps"][number], "status" | "dangerous">[]
): string {
  const done = steps.filter((s) => s.status === "DONE").length;
  const dangerous = steps.filter((s) => s.dangerous).length;
  return `${done}/${steps.length}, опасных: ${dangerous}`;
}

export function getTableData(data: unknown): {
  nodes: AssistantPlanRow[];
  count: number;
} {
  const plans = (
    data as
      | { assistantPlans?: { nodes: AssistantPlanRow[]; count: number } }
      | undefined
  )?.assistantPlans;
  return plans?.nodes ? plans : { nodes: [], count: 0 };
}

export function mapColumns(row: AssistantPlanRow) {
  return [
    row.id,
    row,
    row.organization?.title ?? "-",
    row.user?.email ?? "-",
    row,
    row.status,
    row.createdAt,
  ];
}
